import options from './WidgetOptions.js';
import http from './Http.js';

export default {
    getAll: function() {
        return http.get(options.apiEndpoint() + '/Site?take=999');
    }
};